import { createFileRoute } from '@tanstack/react-router';
import { ManualPaymentsPage } from '../../features/settlement';

export const Route = createFileRoute('/portal/settlement/manual-payments')({ component: ManualPaymentsPage });
